// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__3bs0u","content":"Consent_content__2SiAA","footer":"Consent_footer__1hkz1"};